import { render, staticRenderFns } from "./ListReference.vue?vue&type=template&id=b9c45948&scoped=true&"
import script from "./ListReference.vue?vue&type=script&lang=js&"
export * from "./ListReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c45948",
  null
  
)

export default component.exports